/**
 * O'zbekcha (lotin) — til bo'yicha standart (FR-558).
 *
 * Bu fayl — interfeys matnlarining yagona manbai. Kodda birorta ham satr bo'lmaydi:
 * tayyor interfeysdan satrlarni ajratib olish resurs fayllaridan bir necha barobar
 * qimmatga tushadi (FR-557…FR-560).
 */
export const uzLatn = {
    common: {
        next: 'Keyingisi',
        back: 'Orqaga',
        save: 'Saqlash',
        skip: "O'tkazib yuborish",
        cancel: 'Bekor qilish',
        retry: 'Qayta urinish',
        close: 'Yopish',
        done: 'Tayyor',
        call: "Qo'ng'iroq qilish",
        copy: 'Nusxalash',
        openSettings: 'Sozlamalarni ochish',
        offline: 'Tarmoqsiz',
        online: 'Tarmoqda',
        minutesShort: 'daq',
        hoursShort: 'soat',
        queued: 'navbatda',
        continue: 'Davom etish',
        menu: 'Menyu',
        view: 'Ko‘rish',
        open: 'Ochish',
        confirm: 'Tasdiqlash',
        swipeHint: 'Ikki marta bosing va tasdiqlang',
    },
    onboarding: {
        languageTitle: 'Tilni tanlang',
        languageSubtitle: 'Tilni keyinroq sozlamalardan o‘zgartirish mumkin',
        locationTitle: 'Geolokatsiya',
        locationWhy: 'Dispetcher sizni marshrutda ko‘rishi va mijoz yetib kelish vaqtini bilishi uchun',
        locationRequirement: '«Doimo» darajasidagi ruxsat kerak',
        notificationsTitle: 'Bildirishnomalar',
        notificationsWhy: 'Yangi buyurtma va dispetcher xabarlari darhol yetib borishi uchun',
        batteryTitle: 'Quvvat tejash',
        batteryWhy: 'Tizim ilovani yopib qo‘ymasligi va kuzatuv to‘xtamasligi uchun',
        loginTitle: 'Kirish',
        loginPhone: 'Telefon raqami',
        loginCode: 'SMS-kod',
        loginRequestCode: 'Kod olish',
        loginVerify: 'Kirish',
        // Yangi interfeys (02-ui/redesign/driver-app-spec.md, 4.1–4.5).
        stepOf: 'Qadam {current} / {total}',
        titleOtherLanguage: 'Выберите язык',
        permissionRequest: 'Ruxsat berish',
        permissionGranted: 'Ruxsat berilgan',
        locationSkipWarning: 'Ruxsatsiz smena ochilmaydi. O‘tkazib yuborish uchun yana bir marta bosing',
        notificationsLockScreen: 'Ekran qulfida',
        notificationsSound: 'Ovoz',
        notificationsVibration: 'Tebranish',
        loginPhoneHint: 'Dispetcher ro‘yxatga olgan raqam',
        codeSentTo: 'Kod {phone} raqamiga yuborildi',
        changePhone: 'Raqamni o‘zgartirish',
        resendIn: 'Qayta yuborish {time}',
        resend: 'Kodni qayta yuborish',
        shells: {
            miui: 'Xiaomi · HyperOS',
            emui: 'Huawei · EMUI',
            oneui: 'Samsung · One UI',
            coloros: 'Oppo · Vivo · Realme',
            android: 'Android',
            ios: 'iOS',
            unknown: 'Android',
        },
        // Kirish xatolari: server kodi bo‘yicha, tarmoq matni ekranga chiqmaydi (H-03).
        loginErrors: {
            codeRequestedRecently: 'Kod yaqinda yuborilgan. Biroz kuting va qayta urinib ko‘ring',
            invalidCode: 'Kod noto‘g‘ri yoki muddati o‘tgan',
            tooManyAttempts: 'Urinishlar juda ko‘p. Birozdan keyin qayta urinib ko‘ring',
            invalidPhone: 'Raqam +998 va to‘qqiz raqam ko‘rinishida bo‘lishi kerak',
            network: 'Server bilan aloqa yo‘q. Internetni tekshiring',
            failed: 'Kirib bo‘lmadi. Qayta urinib ko‘ring',
        },
    },
    shift: {
        closedTitle: 'Smena yopiq',
        start: 'Smenani boshlash',
        finish: 'Smenani yakunlash',
        mode: 'Rejim',
        zone: 'Hudud',
        vehicle: 'Transport',
        equipment: 'Mavjud idishlar',
        baseLocation: 'Qaytish nuqtasi',
        batteryWarning: 'Quvvat past: kuzatuv to‘xtashi mumkin',
        // FR-647: faol smena sarlavhasi.
        gpsLabel: 'GPS',
        gpsGood: 'aniq',
        gpsWeak: 'zaif',
        gpsNone: 'signal yo‘q',
        queueLabel: 'Navbat',
        batteryLabel: 'Quvvat',
        // FR-646: fon geolokatsiyasisiz smena ochilmaydi.
        blockedNoBackgroundLocation: 'Fon geolokatsiyasi yoqilmagan. Smenani ochish uchun «Doimo» ruxsatini bering.',
        warnNotifications: 'Bildirishnomalar o‘chirilgan: yangi buyurtmani sezmay qolasiz',
        warnBatterySaver: 'Quvvat tejash yoqilgan: ilova yopilib qolishi mumkin',
        // FR-545: mol kuryerda bo‘lsa smena yakunlanmaydi.
        blockedGoodsWithCourier: 'Topshirilmagan mol bor. Avval uni jo‘natish nuqtasiga qaytaring.',
        blockedStopsPending: 'Topshiriq yakunlanmagan: barcha nuqtalarni yoping',
        // Smenani ochish: rejim, jo‘natish nuqtasi va hududni tanlash.
        modeExpress: 'Kuryerlik xizmati',
        modeDistribution: 'Distributsiya',
        pickupLocation: 'Jo‘natish nuqtasi',
        openTitle: 'Smenani ochish',
        chooseMode: 'Ish rejimini tanlang',
        chooseLocation: 'Jo‘natish nuqtasini tanlang',
        chooseZone: 'Hududni tanlang',
        loadingOptions: 'Variantlar yuklanmoqda…',
        noModes: 'Hisobingizga birorta ham bo‘lim biriktirilmagan. Dispetcherga murojaat qiling.',
        noLocations: 'Mavjud jo‘natish nuqtalari yo‘q. Dispetcherga murojaat qiling.',
        locationWithoutZone: 'Nuqta birorta ham hududga kirmaydi. Dispetcher uni hududga biriktirishi kerak.',
        optionsFailed: 'Smena variantlarini yuklab bo‘lmadi',
        // Server rad etishlari (RFC 9457 `code`).
        openRefusedMode: 'Bu rejim hisobingiz uchun mavjud emas',
        openRefusedAlreadyOpen: 'Smena allaqachon ochilgan',
        openRefusedNoLocation: 'Jo‘natish nuqtasi tanlanmagan',
        openRefusedInvalid: 'Server smena ma’lumotlarini qabul qilmadi. Dispetcherga murojaat qiling.',
        openFailed: 'Smenani ochib bo‘lmadi',
        finishRefusedAlreadyFinished: 'Smena allaqachon yakunlangan',
        finishFailed: 'Smenani yakunlab bo‘lmadi',
        commandOffline: 'Aloqa yo‘q. Smenani faqat onlayn ochish yoki yakunlash mumkin.',
        title: 'Smena',
        summaryEmpty: 'Biriktirish smena ochilganda ko‘rinadi',
        offlineBanner: 'Tarmoq yo‘q. Amallar saqlanadi va keyin yuboriladi',
        blockedReason: 'Fon geolokatsiyasisiz smena ochilmaydi',
        gpsNoneBanner: 'GPS signali yo‘q: dispetcher sizni xaritada ko‘rmayapti',
        returnPoint: 'Qaytarish nuqtasi',
        finishReady: 'Barcha nuqtalar yopilgan. Smenani yakunlash mumkin',
        onShift: 'Smenada',
        startTitle: 'Smenani boshlang',
    },
    task: {
        title: 'Topshiriq',
        etaNext: 'Keyingi nuqtagacha',
        etaComplete: 'Topshiriq tugashi',
        etaReturn: 'Bazaga qaytish',
        empty: 'Hozircha nuqtalar yo‘q',
        currentLeg: 'Hozirgi yo‘nalish',
        // FR-570.4: topshiriq dispetcher tomonidan o‘zgartirildi.
        changed: 'Topshiriq o‘zgardi: nuqtalar tartibini tekshiring',
        arrivalEta: 'Yetib borish',
        // Marshrutni ekspeditor o‘zi tahrirlaydi (distribution).
        routeNavigate: 'Butun marshrut navigatorda',
        planOpen: 'Tartibni o‘zgartirish',
        planTitle: 'Nuqta tartibi',
        planMoveFirst: 'Birinchi',
        planMoveLast: 'Oxirgi',
        planMoveEarlier: 'Oldinroq',
        planMoveLater: 'Keyinroq',
        planTargetAt: 'Shu vaqtgacha yetkazish…',
        planTargetLabel: 'Yetkazish vaqti',
        planTargetPlaceholder: 'SS:DD',
        planTargetClear: 'Vaqtni olib tashlash',
        planTargetHint: 'Vaqt qoʻlda belgilangan tartibingizni bekor qiladi: reys muddatlar boʻyicha qayta tuziladi',
        planPinned: 'Tartibni siz belgilagansiz',
        planOffline: 'Tartibni o‘zgartirish uchun internet kerak',
        planNotAllowed: 'Bu topshiriqda marshrutni o‘zgartirib bo‘lmaydi',
        planStopNotMovable: 'Bu nuqtani ko‘chirib bo‘lmaydi',
        planInvalid: 'Qiymat noto‘g‘ri',
        planFailed: 'O‘zgartirib bo‘lmadi, qayta urinib ko‘ring',
        planTimeInvalid: 'Vaqtni SS:DD ko‘rinishida kiriting',
        planTimePassed: 'Bu vaqt bugun o‘tib ketgan',
        emptyTitle: 'Hozircha topshiriq yo‘q',
        emptyText: 'Buyurtma kelganda bildirishnoma keladi',
        upcoming: 'Keyingi nuqtalar',
        completedSection: 'Bajarilgan ({count})',
        openStop: '{number}-nuqtani ochish',
        sheet: 'Panel',
        sheetCollapsed: 'yig‘ilgan',
        sheetHalf: 'yarim',
        sheetExpanded: 'to‘liq',
        mapNotConnected: 'Xarita ulanmagan',
        zoomIn: 'Yaqinlashtirish',
        zoomOut: 'Uzoqlashtirish',
        myLocation: 'Mening joylashuvim',
        navigateTo: 'Navigatsiya: {number}-nuqta',
    },
    stop: {
        typePickup: 'Olib ketish',
        typeDropoff: 'Topshirish',
        typeReturn: 'Qaytarish',
        entrance: 'Kirish',
        floor: 'Qavat',
        apartment: 'Xonadon',
        doorPhone: 'Domofon',
        doorPhoneCopied: 'Domofon kodi nusxalandi',
        comment: 'Izoh',
        recipient: 'Qabul qiluvchi',
        items: 'Tarkibi',
        cargoCategory: 'Yuk toifasi',
        requiredEquipment: 'Kerakli idish',
        navigate: 'Navigatsiya',
        arrived: 'Yetib keldim',
        pickedUp: 'Oldim',
        pickupFailed: 'Mol berilmadi',
        delivered: 'Yetkazildi',
        failed: 'Yetkazilmadi',
        handedOver: 'Topshirdim',
        reasonRequired: 'Sababni tanlang',
        reasonsUnavailable: 'Sabablar ro‘yxati yuklanmagan',
        // FR-587.2: guruhning umumiy raqami yirik, TMS raqami mayda.
        groupNumber: 'Buyurtma raqami',
        tmsNumber: 'TMS raqami',
        deadline: 'Muddat',
        nextStop: 'Keyingi nuqta',
        title: '{number}-nuqta',
        failConfirm: 'Yetkazilmadi deb belgilash',
        pickupFailConfirm: 'Mol berilmadi deb belgilash',
        commentOptional: 'Izoh (ixtiyoriy)',
        saved: 'Saqlandi',
        savedQueued: 'Saqlandi · navbatda',
        details: 'Batafsil',
        reasonAsked: 'Sabab so‘raladi',
        returnOrders: 'Qaytariladigan buyurtmalar',
    },
    offer: {
        title: '+1 buyurtma',
        increase: 'Vaqt oshishi',
        newComplete: 'Yangi tugash vaqti',
        accept: 'Qabul qilish',
        decline: 'Rad etish',
        declineReason: 'Rad etish sababi',
        pickup: 'Olib ketish manzili',
        dropoff: 'Topshirish manzili',
        deadline: 'Muddat',
        // FR-533: javob berilmasa, buyurtma keyingi nomzodga o‘tadi.
        expiresIn: 'Javob berish vaqti',
        expired: 'Vaqt tugadi: buyurtma boshqa kuryerga o‘tdi',
    },
    messages: {
        title: 'Murojaatlar',
        reply: 'Javob berish',
        empty: 'Murojaatlar yo‘q',
        answered: 'Javob berilgan',
        yourAnswer: 'Javobingiz: {answer}',
        waiting: 'Javob kutilmoqda',
        sent: 'Javob yuborildi',
    },
    diagnostics: {
        title: 'Diagnostika',
        fix: 'Tuzatish',
        permissionGranted: 'Berilgan',
        permissionDenied: 'Berilmagan',
        sendLog: 'Jurnalni yuborish',
        logQueued: 'Jurnal yuborish navbatiga qo‘yildi',
        backgroundLocation: 'Fon geolokatsiyasi',
        notifications: 'Bildirishnomalar',
        batterySaver: 'Quvvat tejash rejimi',
        batteryGuide: 'Quvvat tejash bo‘yicha ko‘rsatma',
        locationAlways: 'Doimo ruxsat berilgan',
        locationNotAlways: 'Doimo ruxsati berilmagan',
        on: 'Yoqilgan',
        off: 'O‘chirilgan',
        done: 'Bajarilgan',
        notDone: 'Bajarilmagan',
        allGood: 'Hammasi joyida',
        problems: '{count} ta muammo',
        permissions: 'Ruxsatlar',
        sync: 'Sinxronlash',
    },
    sync: {
        pending: 'Yuborilmagan amallar',
        conflict: 'Topshiriq o‘zgargan: amal qo‘llanmadi',
        duplicate: 'Amal allaqachon qabul qilingan',
    },
    /**
     * Tillarning o'z nomlari.
     *
     * Har ikkala lokalda bir xil: tilni tanlash ekranini kuryer hali tushunmaydigan
     * tilda ko'rsatish — tanlovni ma'nosiz qiladi.
     */
    languages: {
        uzLatn: "O'zbekcha",
        ru: 'Русский',
    },
    /** Smena hisoboti (FR-554). */
    report: {
        title: 'Smena hisoboti',
        workedTime: 'Ish vaqti',
        runs: 'Reyslar',
        stops: 'Nuqtalar',
        delivered: 'Yetkazilgan',
        notDelivered: 'Yetkazilmagan',
        returns: 'Qaytarilgan',
        distance: 'Masofa',
        etaPlanFact: 'ETA reja/fakt',
        returnPlanFact: 'Bazaga qaytish reja/fakt',
        empty: 'Hisobot smena yakunlangach paydo bo‘ladi',
        planFact: 'Reja va fakt',
    },
    /** «Mening hududim» (FR-648). */
    zone: {
        title: 'Mening hududim',
        homePoint: 'Uy nuqtasi',
        proposeHome: 'Boshqa uy nuqtasini taklif qilish',
        // Kuryer biriktiruvni o'zi o'zgartira olmaydi: administrator tasdiqlaydi.
        proposalPending: 'Taklif administrator tasdig‘ini kutmoqda',
        assignedZones: 'Biriktirilgan hududlar',
        pickupLocations: 'Jo‘natish nuqtalari',
        mapUnavailable: 'Xarita hozircha mavjud emas',
        notAssigned: 'Biriktirilmagan',
        mapLater: 'Xarita ulanganda mavjud bo‘ladi',
    },
    /** Tarix: faqat o'z smenalari (FR-202). */
    history: {
        title: 'Tarix',
        empty: 'Yakunlangan smenalar yo‘q',
        entry: 'Nuqtalar: {stops} · yetkazilgan: {delivered}',
    },
    settings: {
        title: 'Sozlamalar',
        language: 'Til',
        sound: 'Ovoz',
        vibration: 'Tebranish',
        notifications: 'Bildirishnomalar',
        controls: 'Boshqaruv',
        tapConfirm: 'Tasdiqlash: bosish bilan',
        tapConfirmHint: 'Surish o‘rniga tugma va tasdiqlash oynasi',
        about: 'Ilova haqida',
        version: 'Versiya',
    },
    /** Menyu (driver-app-spec.md, 4.13). */
    menu: {
        title: 'Menyu',
    },
    /**
     * Buyurtma holatlari — yagona jadval (TMS_WEB_CABINET_UX.md, 2.3.1-bo'lim).
     *
     * Ilova va dispetcher kabineti bir xil so'zlarni ishlatadi: ekranlar o'rtasidagi
     * farq turli mohiyat sifatida o'qiladi.
     */
    status: {
        new: 'Yangi',
        assigned: 'Tayinlangan',
        picked_up: 'Buyurtma olindi',
        in_transit: "Yo'lda",
        delivered: 'Yetkazildi',
        not_delivered: 'Yetkazilmadi',
        unassigned: 'Ijrochisiz',
        cancelled: 'Bekor qilindi',
        returned: 'CT ga qaytarildi',
        resolved: 'Qaror qabul qilindi',
        goodsWithCourier: 'Tovar kuryerda',
        returnStop: 'Tovarni qaytarish',
        atRisk: 'Muddat xavf ostida',
    },
    /**
     * Kabinet — dispetcher ish o'rni (02-ui/TMS_WEB_CABINET_UX.md).
     *
     * Holat nomlari bu yerda takrorlanmaydi: ular `status` bo'limida, yagona jadvalda
     * (2.3.1-bo'lim). Ekranlar o'rtasidagi farq turli mohiyat sifatida o'qiladi.
     */
    cabinet: {
        period: {
            months: [
                'Yanvar',
                'Fevral',
                'Mart',
                'Aprel',
                'May',
                'Iyun',
                'Iyul',
                'Avgust',
                'Sentabr',
                'Oktabr',
                'Noyabr',
                'Dekabr',
            ],
            monthsOf: [
                'yanvar',
                'fevral',
                'mart',
                'aprel',
                'may',
                'iyun',
                'iyul',
                'avgust',
                'sentabr',
                'oktabr',
                'noyabr',
                'dekabr',
            ],
            weekdays: ['Du', 'Se', 'Ch', 'Pa', 'Ju', 'Sh', 'Ya'],
            dayMonth: '{day}-{month}',
            label: 'Davr',
            today: 'Bugun',
            yesterday: 'Kecha',
            week: 'Shu hafta',
            month: 'Shu oy',
            all: 'Butun davr',
            reset: 'Tozalash',
            days: 'kun',
            previousMonth: 'Oldingi oy',
            nextMonth: 'Keyingi oy',
        },
        nav: {
            monitoring: 'Monitoring',
            flow: 'Yetkazishlar',
            live_map: 'Xarita',
            resolutions: 'Tahlil',
            returns: 'Tovar kuryerda',
            import: 'CSV import',
            locations: 'Nuqtalar',
            zones: 'Hududlar',
            drivers: 'Kuryerlar',
            pickup_matrix: 'Biriktirish matritsasi',
            integrations: 'Integratsiyalar',
            feature_flags: 'Bayroqlar',
            parameters: 'Parametrlar',
            slo: 'SLO',
            audit: 'Audit jurnali',
            runs: 'Reyslar',
            templates: 'SMS andozalari',
            users: 'Foydalanuvchilar',
        },
        modes: {
            express: 'Kuryerlik xizmati',
            distribution: 'Distribyutsiya',
        },
        users: {
            name: 'F.I.Sh.',
            phone: 'Telefon',
            role: 'Rol',
            departments: 'Bo‘limlar',
            noDepartment: 'Bo‘limsiz — ma’lumotlarni ko‘rmaydi',
            saveFailed: 'Bo‘limlarni saqlab bo‘lmadi',
            filter: {
                all: 'Barchasi',
                admin: 'Administratorlar',
                dispatcher: 'Logistlar',
                driver: 'Kuryerlar',
            },
            roles: {
                admin: 'Administrator',
                dispatcher: 'Logist',
                driver: 'Kuryer',
            },
        },
        /** Kuryerlar: ro‘yxat va qo‘shish (FR-508, FR-629). */
        drivers: {
            add: 'Kuryer qo‘shish',
            createTitle: 'Yangi kuryer',
            fullName: 'F.I.Sh.',
            phone: 'Telefon',
            phoneHint: 'Kuryer ilovaga shu raqam bilan kiradi: +998 va to‘qqiz raqam',
            employment: 'Bandlik',
            employmentNone: 'Ko‘rsatilmagan',
            employmentKinds: {
                staff: 'Shtatdagi',
                contracted: 'Shartnoma asosida',
            },
            externalCode: 'Tashqi kod',
            externalCodeHint: 'Buyurtmachining hisob tizimidagi tabel raqami — ixtiyoriy',
            language: 'Ilova va bildirishnomalar tili',
            languages: {
                uz: "O'zbekcha",
                ru: 'Русский',
            },
            departments: 'Bo‘limlar',
            departmentsHint: 'Kuryer faqat belgilangan bo‘limlarda ko‘rinadi va buyurtma oladi',
            active: 'Faol — smenaga chiqishi mumkin',
            status: 'Holat',
            statusActive: 'Faol',
            statusInactive: 'O‘chirilgan',
            required: 'majburiy',
            submit: 'Kuryerni qo‘shish',
            saving: 'Saqlanmoqda…',
            created: 'Kuryer qo‘shildi',
            empty: 'Hozircha kuryerlar yo‘q',
            emptyCanCreate: 'Hozircha kuryerlar yo‘q. «Kuryer qo‘shish» tugmasini bosing — shundan so‘ng kuryer ilovaga o‘z telefon raqami bilan kira oladi.',
            emptyReadOnly: 'Hozircha kuryerlar yo‘q. Ularni administrator qo‘shadi.',
            errors: {
                fullNameRequired: 'F.I.Sh.ni kiriting',
                fullNameTooLong: 'F.I.Sh. ruxsat etilganidan uzun',
                phoneInvalid: 'Raqam +998 va to‘qqiz raqam ko‘rinishida bo‘lishi kerak',
                externalCodeTooLong: 'Tashqi kod ruxsat etilganidan uzun',
                modesRequired: 'Kamida bitta bo‘limni belgilang',
                phoneTaken: 'Bu raqam tizimda allaqachon ro‘yxatdan o‘tgan',
                externalCodeTaken: 'Bu tashqi kod boshqa kuryerga biriktirilgan',
                departmentForbidden: 'Kuryerlarni faqat o‘z bo‘limlaringizga qo‘shish mumkin',
                forbidden: 'Sizda kuryer qo‘shish huquqi yo‘q',
                validation: 'Server ma’lumotlarni rad etdi — belgilangan maydonlarni tekshiring',
                failed: 'Kuryerni qo‘shib bo‘lmadi. Qayta urinib ko‘ring; yordam bermasa — kodni qo‘llab-quvvatlash xizmatiga yuboring',
                code: 'Xato kodi',
            },
        },
        auth: {
            lead: 'Faqat yetkazib berish xizmati xodimlari uchun.',
            note: 'Kirish huquqini xizmat administratori beradi.',
            title: 'TMS kabinetiga kirish',
            phone: 'Telefon raqami',
            phoneExample: '+998 90 123 45 67',
            password: 'Parol',
            submit: 'Kirish',
            failed: 'Telefon raqami yoki parol mos kelmadi',
            locked: 'Kirish vaqtincha yopiq: urinishlar soni oshib ketdi',
        },
        flow: {
            columnAmount: 'Summa',
            columnClient: 'Mijoz',
            columnCourier: 'Kuryer',
            details: 'batafsil',
            currency: 'so‘m',
            stagesLabel: 'Yetkazish bosqichlari',
            stages: {
                accepted: 'Qabul qilindi',
                assigned: 'Kuryer tayinlandi',
                pickedUp: 'Oldi',
                inTransit: 'Yo‘lda',
                delivered: 'Topshirildi',
            },
            found: 'topildi',
            searchPlaceholder: 'Raqam, manzil, qabul qiluvchi yoki kuryer',
            columnDepartment: 'Bo‘lim',
            columnAddress: 'Manzil',
            columnRecipient: 'Qabul qiluvchi',
            columnDue: 'Muddat',
            columnState: 'Holat',
            columnAction: 'Amal',
            open: 'Ochish',
            courier: 'kuryer',
            lateBy: 'kechikmoqda',
            overdueBy: 'muddati o‘tgan',
            etaAt: 'yetib borish',
            title: 'Yetkazishlar',
            create: 'Qo‘lda kiritish',
            import: 'CSV import',
            chips: {
                attention: 'Diqqat talab',
                finished: 'Yakunlangan',
                all: 'Hammasi',
                at_risk: 'Xavf ostida',
                unassigned: 'Ijrochisiz',
                triage: 'Ko‘rib chiqishda',
                goods: 'Mol kuryerda',
                new: 'Yangi',
                active: 'Ishda',
                done: 'Bajarilgan',
                deferred: 'Keyinga qoldirilgan',
                returned: 'Qaytarilgan',
                cancelled: 'Bekor qilingan',
            },
            columnNumber: 'Buyurtma',
            columnStatus: 'Holat',
            columnRoute: 'Yo‘nalish',
            columnDeadline: 'Muddat',
            columnEta: 'Prognoz',
            columnDriver: 'Kuryer',
            columnPickup: 'Jo‘natish nuqtasi',
            noDriver: 'tayinlanmagan',
            more: 'Yana',
            shown: 'Ko‘rsatildi',
            // O'zbekchada ko'plik shakli bitta: uchala shakl ham bir xil, lekin aniq
            // ko'rsatilgan — kalitlar tarkibi ikki tilda bir xil bo'lishi kerak.
            newOrders: ['yangi buyurtma', 'yangi buyurtma', 'yangi buyurtma'],
        },
        order: {
            title: 'Buyurtma',
            planFact: 'Reja / fakt',
            shouldArrive: 'kelishi kerak edi',
            arrived: 'keldi',
            pickedUp: 'oldi',
            handedOver: 'topshirdi',
            driver: 'Kuryer',
            equipment: 'Idish',
            cargoCategory: 'Yuk toifasi',
            mode: 'Rejim',
            items: 'Tarkibi',
            attempts: 'Urinishlar',
            resolutions: 'Qarorlar',
            ctMessages: 'CT murojaatlari',
            changeLog: 'O‘zgarishlar jurnali',
            recipient: 'Qabul qiluvchi',
            driverPhoneNote: 'Kuryer raqami mijozga uzatilmaydi',
            coordinates: 'Koordinatalar',
            coordinatesMissing: 'Manzil xaritada topilmadi — nuqtani qoʻlda kiriting',
            coordinatesManual: 'Qoʻlda kiritilgan',
            latitude: 'Kenglik',
            longitude: 'Uzunlik',
            saveCoordinates: 'Koordinatalarni saqlash',
            zone: 'Hudud',
            noZone: 'Hududdan tashqarida — avtomatik tayinlanmaydi',
            copy: 'Nusxalash',
        },
        assignment: {
            title: 'Ijrochini tanlash',
            recommended: 'tavsiya etiladi',
            load: 'yuklama',
            increase: 'topshiriqqa qo‘shiladi',
            willDeliver: 'yetkazadi',
            deadline: 'muddat',
            deadHead: 'yetib borish',
            assign: 'Tayinlash',
            excluded: 'Chiqarib tashlanganlar',
            force: 'Majburiy tayinlash',
            forceReason: 'Majburiy tayinlash sababi',
            empty: 'Mos kuryer yo‘q',
            unknownDriver: 'Kuryer',
            exclusions: {
                no_equipment: 'kerakli idish yo‘q',
                not_attached_to_location: 'nuqtaga biriktirilmagan',
                max_orders_reached: 'buyurtmalar chegarasiga yetgan',
                deadline_violated: 'muddatga ulgurmaydi',
                out_of_zone: 'o‘z hududidan tashqarida',
                no_route: 'marshrut tuzilmadi',
            },
        },
        resolutions: {
            title: 'Yetkazilmagan buyurtmalar tahlili',
            waiting: 'kutilmoqda',
            reason: 'Kuryer ko‘rsatgan sabab',
            ctHandled: 'Qaror CT sun’iy intellekt konturi tomonidan qabul qilingan',
            decisionCancel: 'Bekor qilish',
            decisionReschedule: 'Ko‘chirish',
            decisionReassign: 'Qayta tayinlash',
            returnToCt: 'CT ga qaytarish',
            newDeadline: 'Yangi muddat',
            empty: 'Tahlil qilinadigan buyurtma yo‘q',
        },
        returns: {
            title: 'Tovar kuryerda',
            byDriver: 'Kuryer bo‘yicha',
            returnTo: 'Qaytarish nuqtasi',
            positions: 'pozitsiya',
            empty: 'Topshirilmagan tovar yo‘q',
        },
        create: {
            title: 'Buyurtmani qo‘lda kiritish',
            department: 'Bo‘lim',
            sectionFrom: 'Qayerdan',
            sectionTo: 'Qayerga',
            sectionCargo: 'Yuk',
            sectionTerms: 'Shartlar',
            pickupLocation: 'Jo‘natish nuqtasi',
            address: 'Manzil',
            entrance: 'Kirish',
            floor: 'Qavat',
            apartment: 'Xonadon',
            doorPhone: 'Domofon',
            recipientName: 'Qabul qiluvchi',
            recipientPhone: 'Telefon',
            comment: 'Izoh',
            cargoCategory: 'Yuk toifasi',
            items: 'Tarkibi',
            equipment: 'Kerakli idish',
            deadline: 'Muddat',
            doorToDoor: 'Eshikkacha',
            consent: 'SMS uchun rozilik',
            itemsHint: 'Har bir qatorda bitta pozitsiya',
            language: 'Bildirishnoma tili',
            checkFeasibility: 'Bajarilishini tekshirish',
            submit: 'Buyurtma yaratish',
            feasible: 'Bajarilishi mumkin',
            infeasible: 'Bajarib bo‘lmaydi',
            earliest: 'Eng yaqin mumkin bo‘lgan vaqt',
            availableCouriers: 'Bo‘sh kuryerlar',
        },
        importCsv: {
            title: 'CSV import',
            choose: 'Faylni tanlang',
            preview: 'Ko‘rib chiqish',
            apply: 'Qo‘llash',
            rows: 'satr',
            valid: 'to‘g‘ri',
            invalid: 'xatolik bilan',
            dryRunNote: 'Avval ko‘rib chiqish: faqat to‘g‘ri satrlar qo‘llanadi',
            errors: {
                empty_file: 'fayl bo‘sh',
                missing_column: 'majburiy ustun yo‘q',
                invalid: 'noto‘g‘ri qiymat',
                rejected: 'buyurtma rad etildi',
                isNotEmpty: 'bo‘sh qiymat',
                matches: 'noto‘g‘ri format',
                out_of_zone: 'manzil yetkazish hududidan tashqarida',
                unknown_location: 'noma’lum jo‘natish nuqtasi',
                missing_location: 'jo‘natish nuqtasi ko‘rsatilmagan',
                invalid_data: 'noto‘g‘ri maʼlumot',
                deadline_unreachable: 'muddatga ulgurib bo‘lmaydi',
            },
        },
        directories: {
            locations: 'Jo‘natish nuqtalari',
            zones: 'Hududlar',
            drivers: 'Kuryerlar',
            externalCode: 'Tashqi kod',
            name: 'Nomi',
            type: 'Turi',
            address: 'Manzil',
            active: 'Faol',
            readOnly: 'Faqat ko‘rish uchun',
            locationTypes: {
                warehouse: 'Ombor',
                pharmacy: 'Dorixona',
                store: 'Do‘kon',
            },
        },
        matrix: {
            title: 'Jo‘natish nuqtasi × kuryerlar',
            ordersInProgress: ['ishdagi buyurtma', 'ishdagi buyurtma', 'ishdagi buyurtma'],
            driversOnShift: ['smenadagi kuryer', 'smenadagi kuryer', 'smenadagi kuryer'],
            avgForecast: 'o‘rtacha prognoz',
            apply: 'Qo‘llash',
            attached: 'biriktirilgan',
        },
        ops: {
            byMode: 'Bo‘limlar qiymatlari',
            integrations: 'Integratsiyalar',
            state: 'Holat',
            lastSuccess: 'Oxirgi muvaffaqiyatli almashinuv',
            errors24h: 'Sutkalik xatolar',
            queue: 'Navbat',
            dlq: 'Yetkazilmagan, ko‘rib chiqish kutilmoqda',
            sloNames: {
                express_delivered_before_deadline: 'Muddatgacha yetkazilgan ekspress-buyurtmalar ulushi',
                events_delivered_first_try: 'CT ga birinchi urinishda yetkazilgan hodisalar ulushi',
                orders_assigned_in_15m: '15 daqiqa ichida tayinlangan buyurtmalar ulushi',
                orders_returned_share: 'Orkestratorga qaytarilgan buyurtmalar ulushi',
            },
            retry: 'Qayta yuborish',
            flags: 'Bayroqlar',
            parameters: 'Parametrlar',
            value: 'Qiymat',
            range: 'Diapazon',
            slo: 'SLI / SLO',
            target: 'Maqsad',
            current: 'Joriy',
            breached: 'buzilgan',
            audit: 'Audit jurnali',
            actor: 'Muallif',
            action: 'Amal',
            entity: 'Obyekt',
            integrationNames: {
                ct_webhook: 'CT ga hodisalarni yuborish',
            },
            states: {
                ok: 'Ishlayapti',
                degraded: 'Uzilishlar bilan',
                failed: 'Ishlamayapti',
            },
        },
        runs: {
            title: 'Reyslar va topshiriqlar',
            pickDriver: 'Kuryerni tanlang',
            run: 'Reys',
            revision: 'Versiya',
            distance: 'Masofa',
            duration: 'Davomiylik',
            complete: 'Tugash',
            returnAt: 'Bazaga qaytish',
            sequence: '№',
            type: 'Turi',
            order: 'Buyurtma',
            address: 'Manzil',
            plan: 'Reja',
            fact: 'Fakt',
            window: 'Oyna',
            up: 'Yuqoriga',
            down: 'Pastga',
            save: 'Tartibni saqlash',
            replan: 'Qayta hisoblash',
            reassign: 'Boshqa kuryerga',
            pinned: 'Qo‘lda',
            locked: 'Joriy yelka',
            late: 'Oynadan kechikish',
            wait: 'Kutish',
            deviation: 'Rejadan chetlanish',
            empty: 'Faol reyslar yo‘q',
            saved: 'Tartib saqlandi va hisob-kitobdan himoyalangan',
            loading: 'Yuklanmoqda',
            km: 'km',
            arrival: 'Yetib kelish',
            lateBy: '{minutes} daq kechikish',
            lateByHours: '{hours} soat {minutes} daq kechikish',
            windowTo: '{to} gacha',
            windowFrom: '{from} dan',
            windowRange: '{from} dan {to} gacha',
            statuses: {
                planned: 'Rejalashtirilgan',
                in_progress: 'Yo‘lda',
                completed: 'Yakunlangan',
                cancelled: 'Bekor qilingan',
            },
        },
        journal: {
            title: 'Audit jurnali',
            when: 'Vaqt',
            who: 'Kim',
            event: 'Hodisa',
            object: 'Obyekt',
            details: 'Tafsilotlar',
            more: 'Yana ko‘rsatish',
            empty: 'Yozuvlar topilmadi',
            total: 'Jami',
            tech: 'texnik maʼlumotlar',
            techHide: 'yashirish',
            today: 'Bugun',
            yesterday: 'Kecha',
            last7: '7 kun',
            pickDates: 'Sanalarni tanlash',
            whoLabel: 'Kim',
            whoAny: 'Barchasi',
            orderSearch: 'Buyurtma raqami',
            categories: {
                all: 'Barchasi',
                orders: 'Buyurtmalar',
                routes: 'Kuryerlar va marshrutlar',
                sessions: 'Kirishlar va seanslar',
                settings: 'Foydalanuvchilar va sozlamalar',
            },
            actors: {
                ct: 'CT integratsiyasi',
                system: 'Tizim',
            },
            objects: {
                order: 'Buyurtma',
                shift: 'Smena',
                task: 'Marshrut',
                driver: 'Kuryer',
                driver_session: 'Kuryer seansi',
                user: 'Foydalanuvchi',
                parameter: 'Parametr',
                ct_request: 'CT so‘rovi',
                embed_session: 'Joylashtirish',
                directory: 'Kuryerni qidirish',
            },
            events: {
                web_login: 'Kabinetga kirish',
                order_created: 'Buyurtma CT dan olindi',
                order_created_manual: 'Buyurtma qo‘lda yaratildi',
                order_updated: 'Buyurtma CT dan yangilandi',
                coordinates_set: 'Koordinatalar qo‘lda kiritildi',
                status_changed: 'Holat o‘zgardi',
                assigned: 'Kuryer tayinlandi',
                distribution_planned: 'Marshrut qayta hisoblandi',
                route_edited_by_driver: 'Kuryer nuqtalar tartibini o‘zgartirdi',
                stops_reordered: 'Dispetcher nuqtalar tartibini o‘zgartirdi',
                reassigned: 'Nuqta boshqa kuryerga berildi',
                session_revoked: 'Kuryer seansi yakunlandi',
                shift_created: 'Kuryer smenani boshladi',
                modes_changed: 'Foydalanuvchi bo‘limlari o‘zgardi',
                courier_action: 'Kuryer harakati',
                permission_denied: 'Kirish rad etildi',
                access_denied: 'CT so‘rovi rad etildi',
                parameter_changed: 'Parametr o‘zgardi',
                message_created: 'CT kuryerga murojaat qildi',
                message_replied: 'Kuryer murojaatga javob berdi',
                code_issued: 'Joylashtirish kodi berildi',
                session_opened: 'Joylashtirish ochildi',
                data_accessed: 'Joylashtirish orqali ko‘rish',
                object_mismatch: 'Joylashtirish begona obyektni so‘radi',
                driver_created: 'Kuryer qo‘shildi',
                installation_switch: 'Boshqa yo‘nalishga o‘tish',
                admin_bootstrapped: 'Birinchi administrator yaratildi',
                lookup_missed: 'Kuryer raqami topilmadi',
            },
            text: {
                serviceClient: 'xizmat mijozi',
                ip: 'IP {ip}',
                forced: 'majburiy',
                reason: 'sabab: {reason}',
                reasons: {
                    departed_to_recipient: 'kuryer qabul qiluvchiga yo‘l oldi',
                    run_loaded: 'reys yuklandi',
                    deadline_forecast: 'prognoz muddatga sig‘maydi',
                    departure_delay: 'jo‘nash kechikdi',
                },
                stops: ['nuqta', 'nuqta', 'nuqta'],
                noLate: 'kechikish yo‘q',
                late: 'kechikishlar: {count}',
                triggerDriver: 'kuryer so‘rovi bilan',
                triggerUrgent: 'shoshilinch buyurtma',
                toEnd: 'nuqta oxiriga ko‘chirildi',
                toStart: 'nuqta boshiga ko‘chirildi',
                toPosition: 'nuqta {position}-o‘ringa ko‘chirildi',
                targetAt: '{time} gacha yetkazish',
                anotherDevice: 'boshqa qurilmadan kirish',
                geolocation: 'geolokatsiya',
                notifications: 'bildirishnomalar',
                batterySaver: 'quvvat tejash',
                yes: 'ha',
                no: 'yo‘q',
                zone: '«{zone}» hududi',
                fieldZone: 'hudud',
                fieldNumber: 'CT raqami',
                fieldPickup: 'jo‘natish nuqtasi',
                fieldMode: 'rejim',
                signatureMismatch: 'imzo noto‘g‘ri',
                noDepartments: 'bo‘limsiz',
                courierKinds: {
                    pickup: 'buyurtmani oldi',
                    arrive: 'nuqtaga yetib keldi',
                    deliver: 'buyurtmani topshirdi',
                    fail: 'yetkazmadi',
                    pickup_failed: 'tovar berilmadi',
                },
            },
        },
        templates: {
            title: 'SMS andozalari',
            code: 'Nuqta',
            language: 'Til',
            body: 'Matn',
            segments: 'Segmentlar',
            length: 'Belgilar',
            enabled: 'Yoqilgan',
            save: 'Saqlash',
            saved: 'Andoza saqlandi',
            hint: 'Kirill alifbosida bitta segment — 70 belgi: uzun matn har bir xabarni ikki-uchga bo‘ladi',
            placeholders: 'O‘rinbosarlar: {{number}}, {{link}}, {{window}}',
            points: {
                order_accepted: 'Buyurtma qabul qilindi',
                window_assigned: 'Yetkazish oynasi belgilandi',
                picked_up: 'Kuryer buyurtmani oldi',
                courier_arrived: 'Kuryer yetib keldi',
                delivered: 'Buyurtma yetkazildi',
                rescheduled: 'Yetkazish ko‘chirildi',
                cancelled: 'Buyurtma bekor qilindi',
            },
        },
        live: {
            connected: 'Jonli',
            reconnecting: 'Qayta ulanmoqda',
            polling: 'Faqat so‘rov bo‘yicha',
            updatedAgo: 'yangilandi',
            mapUnavailable: 'Xarita kaliti sozlanmagan: kuryerlar ro‘yxat bilan ko‘rsatilmoqda',
            staleWarning: 'Pozitsiya eskirgan',
        },
        common: {
            orders: 'Buyurtmalar',
            settings: 'Sozlamalar',
            brand: 'Zenta TMS',
            moreSections: 'Yana',
            user: 'Foydalanuvchi',
            search: 'Buyurtma raqami yoki telefon bo‘yicha qidirish',
            filters: 'Filtrlar',
            reset: 'Tozalash',
            apply: 'Qo‘llash',
            cancel: 'Bekor qilish',
            close: 'Yopish',
            confirm: 'Tasdiqlash',
            reasonRequired: 'Sababni ko‘rsating',
            loading: 'Yuklanmoqda',
            empty: 'Ma’lumot yo‘q',
            emptyFiltered: 'Filtr bo‘yicha hech narsa topilmadi',
            error: 'Xatolik yuz berdi',
            forbidden: 'Bu bo‘limga ruxsatingiz yo‘q',
            departmentForbidden: 'Buyurtma boshqa boʻlimga tegishli: sizda unga kirish huquqi yoʻq',
            logout: 'Chiqish',
            theme: 'Mavzu',
            themeDark: 'Qorong‘i mavzuni yoqish',
            themeLight: 'Yorug‘ mavzuni yoqish',
            installation: 'Yo‘nalish',
            departments: 'Bo‘limlar',
            switchFailed: 'Boshqa yo‘nalishga o‘tib bo‘lmadi',
            of: 'dan',
        },
    },
    /** Quvvat tejash bo'yicha ko'rsatmalar qadamlari (FR-645). */
    battery: {
        miui: {
            autostart: 'Avtomatik ishga tushirishni yoqing',
            noRestrictions: 'Batareya uchun «Cheklovsiz» ni tanlang',
            lockRecents: "Ilovani vazifalar ro'yxatida mahkamlang",
        },
        emui: {
            manualLaunch: "Ishga tushirishni qo'lda boshqarishga o'tkazing",
            protectedApp: "Ilovani himoyalangan ro'yxatga qo'shing",
        },
        oneui: {
            sleepingApps: "«Uxlayotgan ilovalar» ro'yxatidan chiqaring",
            optimisation: 'Batareya optimallashtirishdan chiqaring',
        },
        coloros: {
            autostart: 'Avtomatik ishga tushirishni yoqing',
            background: 'Fonda ishlashga ruxsat bering',
        },
        android: {
            optimisation: 'Batareya optimallashtirishni o‘chiring',
        },
        ios: {
            backgroundRefresh: 'Fonda yangilanishni yoqing',
            lowPowerMode: 'Quvvat tejash rejimini o‘chiring',
        },
    },
};
//# sourceMappingURL=uz-Latn.js.map